






























import {
  SfList, SfLink, SfMenuItem, SfFooter, SubscribeForm
} from '~/components';
import { useCategory } from '~/modules/catalog/category/composables/useCategory';
import { transformFooterList } from '~/helpers/transformFooterList';

import {computed, defineComponent, ref, useContext, useFetch, useRoute} from '@nuxtjs/composition-api';

export default defineComponent({
  components: {
    SubscribeForm,
    SfFooter,
    SfList,
    SfLink,
    SfMenuItem,
    StoreSwitcher: () => import('~/components/StoreSwitcher.vue'),
  },
  setup() {
    const { app } = useContext();
    const { load: footerListLoad, categories: footerList } = useCategory();
    const footerItems = ref(null);
    const route = useRoute();

    const isExternalUrl = (url: string = ''): boolean => /^(https?:)?\/\//i.test(url);

    const resolveFooterLink = (url: string = ''): string => {
      if (!url) return '#';
      return isExternalUrl(url) ? url : app.localePath(url);
    };

    useFetch(async () => {
      await footerListLoad({
        pageSize: 99,
        filters: {
          identifier: { eq: 'footer' },
          is_enabled: { eq: true }
        },
      });

      footerItems.value = transformFooterList(footerList.value?.[0]?.children) || [];
    });

    return {
      footerItems,
      resolveFooterLink,
      isExternalUrl,
    };
  },
});
